import React, { useEffect, useState } from 'react';
import { MdVpnKey, MdContentCopy, MdRefresh } from 'react-icons/md';
import API from '../api';
import { useLanguage } from '../i18n';

// Admin-only card (shown on the Users page): the organization code + staff
// join code that let staff create their own account at /signup.
export default function JoinCodeCard() {
    const { t } = useLanguage();
    const [info, setInfo] = useState(null);
    const [error, setError] = useState('');
    const [copied, setCopied] = useState('');
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        API.get('/signup/join-code').then(({ data }) => setInfo(data)).catch(() => setInfo(null));
    }, []);

    if (!info) return null;

    const run = async request => {
        setBusy(true); setError('');
        try { const { data } = await request(); setInfo(data); }
        catch (err) { setError(err.response?.data?.error || t('joinCode.failed')); }
        finally { setBusy(false); }
    };
    const copy = async (key, text) => {
        try { await navigator.clipboard.writeText(text); setCopied(key); setTimeout(() => setCopied(''), 1800); } catch (e) { /* clipboard blocked */ }
    };
    const inviteLink = `${window.location.origin}/signup?org=${encodeURIComponent(info.system_code || '')}&code=${encodeURIComponent(info.join_code || '')}`;
    const codeBox = { fontFamily: 'monospace', fontWeight: 700, fontSize: 16, background: '#f1f5f9', borderRadius: 8, padding: '6px 12px', display: 'inline-block' };

    return (
        <div className="page-card" style={{ padding: 18, marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <MdVpnKey style={{ color: '#0b5ed7' }} />
                <h6 style={{ margin: 0, fontWeight: 700 }}>{t('joinCode.title')}</h6>
            </div>
            {!info.available ? (
                <p style={{ margin: 0, color: '#64748b', fontSize: 13 }}>{t('joinCode.unavailable')}</p>
            ) : (
                <>
                    <p style={{ margin: '0 0 12px', color: '#64748b', fontSize: 13 }}>{t('joinCode.description')}</p>
                    {error && <div className="alert alert-danger py-2" style={{ fontSize: 13 }}>{error}</div>}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, alignItems: 'flex-end', marginBottom: 12 }}>
                        <div>
                            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 4 }}>{t('joinCode.orgCode')}</div>
                            <span style={codeBox}>{info.system_code}</span>
                        </div>
                        <div>
                            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 4 }}>{t('joinCode.joinCode')}</div>
                            <span style={codeBox}>{info.join_code}</span>
                        </div>
                        <button className="btn btn-outline-secondary btn-sm" disabled={busy}
                            onClick={() => { if (window.confirm(t('joinCode.regenerateConfirm'))) run(() => API.post('/signup/join-code')); }}>
                            <MdRefresh /> {t('joinCode.regenerate')}
                        </button>
                        <button className="btn btn-outline-primary btn-sm" onClick={() => copy('invite', inviteLink)}>
                            <MdContentCopy /> {copied === 'invite' ? t('joinCode.copied') : t('joinCode.copyInvite')}
                        </button>
                    </div>
                    <div className="form-check form-switch" style={{ marginBottom: 6 }}>
                        <input className="form-check-input" type="checkbox" id="joinEnabled" checked={info.enabled} disabled={busy}
                            onChange={e => run(() => API.put('/signup/join-code', { enabled: e.target.checked }))} />
                        <label className="form-check-label" htmlFor="joinEnabled" style={{ fontSize: 13, fontWeight: 600 }}>{t('joinCode.allow')}</label>
                    </div>
                    <div style={{ color: '#94a3b8', fontSize: 12 }}>{t('joinCode.note')}</div>
                </>
            )}
        </div>
    );
}
